export function deepActiveElement(root: DocumentOrShadowRoot = document) {
  if (
    root.activeElement &&
    root.activeElement.shadowRoot &&
    root.activeElement.shadowRoot.activeElement
  ) {
    return deepActiveElement(root.activeElement.shadowRoot);
  }
  return root.activeElement;
}

export function isAppleDevice(): boolean {
  const platform = window.navigator.platform.toLowerCase();
  return (
    platform.indexOf('mac') !== -1 ||
    platform.indexOf('iphone') !== -1 ||
    platform.indexOf('ipad') !== -1
  );
}
